import React from "react";
import Xarrow, { useXarrow } from "react-xarrows";
const Link = (props) => {
  
  return props.dashness == true ? (
    <Xarrow
      start={props.start} //can be react ref
      end={props.end} //or an id
      path="smooth"
      strokeWidth="1.2"
      startAnchor="bottom"
      endAnchor="top"
      color="#5F5F6A"
      labels={<div className="wk-lab" >{props.label? <span className="arr-lbl" >{props.label}</span>:null}</div>}
      dashness={true}
      dashness={{ strokeLen: 5, nonStrokeLen: 5 }}
    />
  ) : (
    <Xarrow
      start={props.start} //can be react ref
      end={props.end} //or an id
      path="smooth"
      strokeWidth="1.2"
      startAnchor="bottom"
      endAnchor="top"
      color="#5F5F6A"
      labels={<div  className="wk-lab" >{props.label? <span className="arr-lbl" >{props.label}</span>:null}</div>}
      dashness={false}
      // dashness={{ strokeLen: 10, nonStrokeLen: 5 }}
    />
  );
};

export default Link;
